document.addEventListener("DOMContentLoaded", function () {
  function bindDiscountHandler() {
    const applyBtn = document.getElementById("apply-discount-button");
    const input = document.getElementById("cart-discount-code");
    const message = document.getElementById("discount-message");
    const loader = document.getElementById("discount-loader");

    if (applyBtn && input && message) {
      applyBtn.addEventListener("click", function () {
        const discountCode = input.value.trim();
        if (!discountCode) {
          message.textContent = "Please enter a discount code.";
          message.className = "text-red-600 text-sm mt-2";
          return;
        }

        message.textContent = "";
        loader.classList.remove("hidden");

        // STEP 1: Set discount (without redirect)
        fetch(`/discount/${discountCode}`, {
          method: "GET",
          headers: {
            "Content-Type": "text/html",
          },
        })
          .then(() => {
            // STEP 2: Refresh the cart drawer section only
            return fetch(`${window.location.pathname}?section_id=cart-drawer`);
          })
          .then((res) => res.text())
          .then((html) => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, "text/html");
            const newDrawer = doc.querySelector("cart-drawer");

            if (newDrawer) {
              document.querySelector("cart-drawer").replaceWith(newDrawer);
              message.textContent = `Discount "${discountCode}" applied!`;
              message.className = "text-green-600 text-sm mt-2";

              // Rebind events on new drawer
              bindDiscountHandler();
            } else {
              throw new Error("Cart drawer not found.");
            }
          })
          .catch((err) => {
            console.error("Discount error:", err);
            message.textContent = "Failed to apply discount. Try again.";
            message.className = "text-red-600 text-sm mt-2";
          })
          .finally(() => {
            loader.classList.add("hidden");
          });
      });
    }
  }

  bindDiscountHandler();
});
